import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import {
    getDivisa
} from '../../utils/helpers'


import { RowDocumentosAsociados } from './RowDocumentosAsociados'

import { 
    downloadFile,
} from '../../actions/common'

class DocumentosAsociados extends Component {
	render() {
        const { documento, enums, downloadFile, divisas } = this.props
        if (!documento) return null



        if (documento.get('documentos').count() === 0) {
            return (
                <div style={{ textAlign: 'center', color: '#bbb' }}>
                    <h3><FontAwesome name="exclamation-circle" /> Este documento no tiene otros documentos asociados</h3>
                </div>
            )
        }

        const moneda = documento.getIn(['cotizacion','moneda'])
        const divisa = getDivisa(divisas, moneda)


		return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>No.</th>
                                    <th style={{ width: '15%' }}>Proveedor</th>
                                    <th style={{ width: '9%' }}>Total</th>
                                    <th style={{ width: '11%' }}>Tipo documento</th>
                                    <th style={{ width: '10%' }}>Estado</th>
                                    <th style={{ width: '9%' }}>Fecha inicio</th>
                                    <th style={{ width: '9%' }}>Fecha entrega</th>
                                    <th>Servicios</th>
                                    <th style={{ textAlign: 'center' }}>Descargas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    documento.get('documentos').map((a, b) =>
                                        <RowDocumentosAsociados origen={documento} documento={a} indice={b} divisa={divisa} key={`tr4[${a.get('id')}]`}
                                            downloadFile={downloadFile} enums={enums}/>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        enums: state.common.get('enums').toJS(),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentosAsociados)


// WEBPACK FOOTER //
// ./src/components/Documentos/DocumentosAsociados.jsx